import React from "react";
import { ZUid } from "src/types/zUid";

type PropsObjectStateLabel = {
  statesLabels: Record<ZUid, string>;
  stateId: ZUid;
};

export const ObjectStateLabel: React.FC<PropsObjectStateLabel> = ({
  statesLabels,
  stateId,
}) => <div>{statesLabels[stateId]}</div>;
